// client/src/pages/Admin/ProjectManager/components/BulkActionToolbar.tsx
/**
 * BULK ACTION TOOLBAR COMPONENT
 * 
 * Toolbar for bulk actions on selected projects.
 * 
 * @module ProjectManager/Components/BulkActionToolbar
 */

import React from 'react';
import { Archive, Check, Download, EyeOff, Star, Trash2, X } from 'lucide-react';

interface BulkActionToolbarProps {
    selectedCount: number;
    isBulkActionLoading: boolean;
    onPublish: () => void;
    onArchive: () => void;
    onFeature: () => void;
    onUnfeature: () => void;
    onExport: () => void;
    onDelete: () => void;
    onClear: () => void;
}

export const BulkActionToolbar: React.FC<BulkActionToolbarProps> = ({
    selectedCount,
    isBulkActionLoading,
    onPublish,
    onArchive,
    onFeature,
    onUnfeature,
    onExport,
    onDelete,
    onClear
}) => {
    if (selectedCount === 0) return null;

    return (
        <div className="bulk-action-toolbar" role="toolbar" aria-label="Bulk actions">
            <div className="bulk-action-info">
                <span className="bulk-action-count">
                    <strong>{selectedCount}</strong> project{selectedCount !== 1 ? 's' : ''} selected
                </span>
                <button
                    className="bulk-action-clear"
                    onClick={onClear}
                    aria-label="Clear selection"
                >
                    <X size={14} />
                    Clear
                </button>
            </div>

            <div className="bulk-action-buttons">
                <button
                    className="bulk-action-btn"
                    onClick={onPublish}
                    disabled={isBulkActionLoading}
                    aria-label="Publish selected projects"
                >
                    <Check size={14} />
                    Publish
                </button>
                <button
                    className="bulk-action-btn"
                    onClick={onArchive}
                    disabled={isBulkActionLoading}
                    aria-label="Archive selected projects"
                >
                    <Archive size={14} />
                    Archive
                </button>
                <button
                    className="bulk-action-btn"
                    onClick={onFeature}
                    disabled={isBulkActionLoading}
                    aria-label="Feature selected projects"
                >
                    <Star size={14} />
                    Feature
                </button>
                <button
                    className="bulk-action-btn"
                    onClick={onUnfeature}
                    disabled={isBulkActionLoading}
                    aria-label="Unfeature selected projects"
                >
                    <EyeOff size={14} />
                    Unfeature
                </button>
                <button
                    className="bulk-action-btn"
                    onClick={onExport}
                    disabled={isBulkActionLoading}
                    aria-label="Export selected projects"
                >
                    <Download size={14} />
                    Export
                </button>
                <button
                    className="bulk-action-btn bulk-action-danger"
                    onClick={onDelete}
                    disabled={isBulkActionLoading}
                    aria-label="Delete selected projects"
                >
                    <Trash2 size={14} />
                    Delete
                </button>
            </div>
        </div>
    );
};